<template>
  <div :class="{'has-logo':showLogo}">
    <logo v-if="showLogo" :collapse="isCollapse" />
    <el-scrollbar wrap-class="scrollbar-wrapper">
      <el-menu
        ref="menu"
        id="menu"
        :default-active="activeMenu"
        :collapse="isCollapse"
        :background-color="variables.menuBg"
        :text-color="variables.menuText"
        :unique-opened="true"
        :active-text-color="variables.menuActiveText"
        :collapse-transition="false"
        mode="vertical"
        @open="handleOpenSub"
        @close="handleCloseSub"
      >
        <sidebar-item
          v-for="(route,i) in routes"
          :key="route.path"
          :index="i"
          :item="route"
          :base-path="route.path"
        />
      </el-menu>
    </el-scrollbar>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Logo from './Logo'
import SidebarItem from './SidebarItem'
import variables from '@/styles/variables.scss'
import { addClass, removeClass } from '@/utils'
export default {
  components: { SidebarItem, Logo },
  computed: {
    ...mapGetters([
      'sidebar'
    ]),
    routes () {
      return this.$store.state.render.routes
      // return this.$router.options.routes.filter((v) => { return !v.hidden })
    },
    activeMenu () {
      const route = this.$route
      const { meta, path } = route
      console.log(route, '55555555')
      // if set path, the sidebar will highlight the path you set
      if (meta.activeMenu) {
        return meta.activeMenu
      }
      this.getShowOption(path)
      return path
    },
    showLogo () {
      return this.$store.state.settings.sidebarLogo
    },
    variables () {
      return variables
    },
    isCollapse () {
      return !this.sidebar.opened
    }
  },
  data () {
    return {
      routerList: []
    }
  },
  methods: {
    getShowOption (index) {
      let code = this.routerList.filter(v => { return v.url === index }).length ? this.routerList.filter(v => { return v.url === index })[0].code : '';
      if (!code) { return }
      this.$axios.get('/menu/getShowOption', { params: { funcId: code } }).then(res => {
        if (res.data.code === '0') {
          window.localStorage.setItem('Auths', JSON.stringify(res.data.data));
        } else {
          window.localStorage.setItem('Auths', JSON.stringify([]));
        }
      })
    },
    handleOpenSub (index) {
      console.log(this.$refs.menu.$el.children, '==3333333333')
      console.log(index, '==3333333333')
      let el = this.$refs.menu.$el.children[index.split(',')[1]];
      let child = this.$refs.menu.$el.children;
      for (let i = 0, l = child.length; i < l; i++) {
        removeClass(child[i], 'item-active')
      }
      addClass(el, 'item-active')
    },
    handleCloseSub (index) {
      let el = this.$refs.menu.$el.children[index.split(',')[1]];
      removeClass(el, 'item-active')
    }
  },
  created () {
    let routerList = []
    this.routes.forEach(v => {
      routerList = routerList.concat(v.children);
    })
    console.log(this.routes, '====')
    this.routerList = routerList;
  }
}
</script>
<style lang='scss' scoped>
/deep/ .el-scrollbar__view {
  overflow: hidden !important;
}
</style>



// WEBPACK FOOTER //
// src/layout/components/Sidebar/index.vue